import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'concourse-close-cutsheet-dialog',
  templateUrl: './close-cutsheet-dialog.component.html',
  styleUrls: ['./close-cutsheet-dialog.component.scss']
})
export class CloseCutsheetDialogComponent implements OnInit {

  @Input() title:string = '';
  @Input() message1:string = '';
  @Input() message2:string = '';
  @Input() message3:string = '';
  @Input() confirm_message:string = 'is this correct?';
  @Input() yes_label:string = 'Yes';
  @Input() no_label:string = 'No';
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
